import { create } from 'zustand';

export const useLayoutStore = create((set, get) => ({
    bannerImageDisplayed: true,
    hasBrandingBanner: false,
    setBannerImageDisplayed: bannerImageDisplayed => set({ bannerImageDisplayed }),
    setHasBrandingBanner: hasBrandingBanner => set({ hasBrandingBanner }),
}));
